export const zh = {
  scene: {
    loading: '正在加载背景…',
    recovering: '正在恢复画面…',
    unavailable: '无法加载背景',
    retryHint: '正在重试。如果加载未完成，请重新打开应用。',
  },
  bootstrap: {
    unsupportedBrowser: {
      title: '不支持此浏览器',
      description: '当前浏览器配置无法运行应用图形。请使用下列其他浏览器打开 Neiro Oracle。',
      browsers: '支持的浏览器',
      requirement: '请使用可运行 WebGL 图形的最新浏览器版本。浏览器或设备设置可能会限制图形功能。',
      safari: 'Safari · iPhone、iPad 和 Mac',
    },
    loadingSpace: '正在准备空间…',
    loadingOracle: '正在打开占卜…',
    startupError: '应用启动失败',
    retry: '重试',
    staleTelegram: 'Telegram 会话已过期。请关闭并重新打开小程序。',
    authTelegramError: '无法确认 Telegram 登录',
    updateTelegramError: '无法更新小程序。请完全关闭后重新打开。',
    missingTelegramData: 'Telegram 未提供启动数据。请关闭并重新打开小程序。',
  },
  back: '返回',
  close: '关闭',
  loading: '加载中…',
  routeReading: {
    loading: '正在打开解读…',
    error: '解读不可用',
    errorHint: '该解读可能已被删除，或属于其他个人资料。',
    retry: '重试',
  },
  save: '保存',
  tomorrow: '明天',
  collapse: '收起',
  app: {
    title: 'NEIRO ORACLE',
    subtitle: '占卜系统 v{{version}}',
    version: 'v{{version}}',
  },
  oracleGuide: {
    eyebrow: 'Neiro Oracle',
    title: '如何使用易经占卜',
    introduction: '两种咨询《易经》的方式，适用于不同需求。',
    accessibilityLabel: '每日卦象与解读指南',
    open: '使用指南',
    close: '关闭指南',
    understood: '知道了',
    daily: {
      title: '每日卦象',
      body: '无需提问。它为你提供一天的主题和实用指引。',
    },
    reading: {
      title: '起卦',
      body: '提出一个具体问题，抛掷硬币时将它记在心中。解读会呈现当前局面、变化及可能的方向。',
    },
    journal: {
      title: '记录',
      body: '每日卦象和解读保存在同一历史记录中。解读后，你可以记录自己的决定。',
    },
    example: {
      title: '有帮助的提问',
      body: '“与团队交谈前，我应该考虑什么？”',
    },
  },
  dailyDetails: {
    title: '详情',
    loading: '正在加载卦象…',
    loadError: '无法加载所选语言的卦象。',
    retry: '重试',
    fullText: '今日主题',
    situationEssence: '自我检视的问题',
    innerTension: '需要留意',
    action: '今天可以做什么',
    askAbout: '就此提问',
    introduction: '每日卦象无需提问。它为你提供一天的主题和实用指引。',
  },
  classicalText: {
    title: '经典原文',
    future: '经典 · 之卦',
    judgment: '卦辞',
    lines: '爻辞',
    parallelLines: '卦爻',
    line: '第 {{number}} 爻',
    lineStatement: '经典爻辞',
    sourceLabel: '易经',
    rulingLine: '主爻',
    specialLine: '特别用辞',
  },
  home: {
    title: 'NEIRO ORACLE',
    subtitle: '占卜系统 v{{version}}',
    statusText: '> 所有系统运行正常',
    daily: {
      title: '每日卦象',
      caption: '无需提问 · 今日主题与指引',
      actionTitle: '今日行动',
      askNow: '开始占卜',
      moreDetails: '阅读更多',
      hideDetails: '隐藏详情',
      detailsTitle: '完整说明',
      lastResult: '上次结果',
      noLastResult: '无',
      emptyState: '暂无解读。开始占卜 →',
      empty: {
        subtitle: '轻点获取今日卦象',
        hint: '一键起卦',
        button: '获取卦象',
      },
      loading: {
        searching: '正在寻找卦象…',
        revealing: '正在揭示六爻…',
      },
      pinnedToday: '已设为今日卦象',
      newSign: '新卦象',
      resetReasons: {
        title: '更新原因',
        sleep: '睡醒了',
        situationChanged: '情况已改变',
        other: '其他',
      },
      resetConfirm: {
        title: '更新卦象？',
        message: '为新的清醒周期更新卦象？当前卦象将保留在日记中。',
        confirm: '更新',
        cancel: '取消',
      },
      nextUpdate: {
        prefix: '下一个新卦象 —',
        afterSleep: '下次睡醒后',
        tomorrow: '明天 07:00',
        or: '或',
        available: '现在可用',
      },
      updated: '卦象已更新 — 新的清醒周期',
      limitReached: '今日更新次数已达上限',
      disclaimer: '用于自我反思与娱乐，不构成医疗或财务建议。',
    },
    question: {
      title: '有具体的问题？',
      subtitle: '解读探索当前局面、变化及可能的方向',
      askNow: '开始占卜',
      hint: '无需选择主题。呈现之卦、当前爻及变爻',
    },
    buttons: {
      iching: '易经占卜',
      designSystem: '设计系统',
      simpleTest: '简单测试',
      hexagramTest: '卦象测试',
    },
  },
  iching: {
    title: '易经占卜',
    subtitle: '移动版 v{{version}}',
    throwCoins: '抛掷硬币',
    castingHexagram: '正在起卦…',
    generationError: '卦象未能生成。请检查连接后重新起卦。',
    retry: '重试',
    castingWisdom: {
      '1': '千里之行，始于足下',
      '2': '不怕慢，就怕站',
      '3': '柔能克刚，静能制躁',
      '4': '天地之间，唯变不变',
      '5': '智者如水，随器而形',
      '6': '卦象既成，答案已在心中',
    },
    instruction: '轻点起卦，获取指引',
    linkActive: '连接已启用',
    backButton: '← 首页',
    newDivination: '重新占卜',
    sections: {
      hexagrams: '卦象',
      interpretation: '解读',
      aiInsights: 'AI 洞见',
      general: '总体解读',
      love: '爱情与关系',
      work: '工作与事业',
      health: '健康与身心状态',
      travel: '旅行与旅程',
      changingLines: '变爻',
      futureHexagram: '可能的状态',
      structuralFocus: '维系局面的因素',
    },
    hexagram: {
      current: '当前',
      future: '可能',
      present: '当前局面',
      outcome: '可能的方向',
      changing: '变爻',
      structural: '维系局面的因素',
    },
    insights: {
      analyzing: '正在生成解读…',
      transformation:
        '“{{current}}”可能向“{{future}}”转变。变爻：{{changes}}。',
      stable: '没有变爻。局面延续当前方向。',
    },
    changingLines: '变爻',
    changingLinesDescription: '这些爻指出局面可能发生变化之处。',
    governingLineHint: '皇冠标记此卦的主爻。',
    changingLinesTitle: '变爻（{{count}}）',
    structuralFocusTitle: '什么在维系当前局面',
    structuralFocusDescription: '没有变爻时，这些位置显示当前局面的支撑因素。',
    lineNumber: '第 {{number}} 爻',
    changingLinesNote: '请仔细阅读这些爻辞：它们指出变化正在发生之处。',
  },
  ask: {
    throw: {
      prepare: '简要提出问题，并将它记在心中。',
      tips: {
        heart: '说出你在意的事',
        specific: '描述具体情况',
        openEnded: '问问自己应该考虑什么',
      },
      example: '例如：“做决定前，我应该考虑什么？”',
      guide: {
        title: '准备',
        bestTime: '在能够平静思考答案时提问',
        todayGood: '在重要决定前，留出核实事实的时间',
      },
    },
    result: {
      sections: {
        future: '可能的方向',
        present: '当下正在发生什么',
        changes: '解读重点',
        structuralFocus: '支撑因素',
        advice: '如何行动',
      },
      accessibility: {
        advice: '如何行动。建议',
      },
      content: {
        check: '自我检视的问题',
        caution: '需要留意',
        primaryLine: '主要重点',
        secondaryLine: '补充细节',
        relatingHint: '之卦提供另一个主题，可与当前局面对照思考。',
        visibleStructure: '局面如何形成',
        resultStructure: '局面可能如何发展',
        hiddenDynamic: '深层正在发生什么',
        hiddenCondition: '什么可能影响结果',
        corePattern: '值得关注之处',
        coreTension: '困难在哪里',
        question: '你的问题',
        questionContext: '结合所问之事',
        currentAction: '现在可以做什么',
        entryCondition: '如何迈向这一状态',
        progressMarker: '如何识别进展',
      },
      changeDepth: {
        stable: '没有变爻。下方内容显示当前局面的支撑因素。',
        boundary: '变化涉及局面的开始或结束。',
        internal: '变化涉及局面的内部动态。',
        systemic: '变化触及局面的基础，可能改变其走向。',
      },
      buttons: {
        decide: '作出决定',
      },
      more: '阅读更多',
      skeleton: {
        loading: '加载中…',
      },
    },
    acceptDecision: {
      back: '返回',
      title: '作出决定',
      subtitle: '补充背景，方便日后回顾这次决定。',
      reading: '决定依据',
      questionLabel: '这个决定与什么有关？',
      questionPlaceholder: '简要描述情况或问题…',
      questionHint: '选填。此背景信息将保存在日记中。',
      confirm: '确认并保存',
      saving: '正在保存…',
      cancel: '取消',
      errorTitle: '决定未保存',
      errorMessage: '请重试。',
    },
  },
  themes: {
    title: '主题',
    dark: '深色',
    light: '浅色',
    autumn: '秋日',
    active: '已启用',
    dark_description: '深色界面，柔和点缀',
    light_description: '简洁现代的浅色主题',
    autumn_description: '灵感源自秋天的温暖大地色调',
  },
  ui: {
    screenTitle: '页面标题',
    info: '信息',
    language: '语言',
    interfaceSettings: '语言与主题',
    loadingStates: {
      loading: '加载中…',
      processing: '正在处理…',
      connecting: '正在连接…',
      deleting: '正在删除…',
    },
  },
  tabs: {
    home: '首页',
    journal: '记录',
    hexagrams: '六十四卦',
    profile: '个人资料',
  },
  desktop: {
    oracle: '占卜',
    brandSubtitle: '以易经辅助决策',
    appearance: '外观',
    theme: '界面主题',
  },
  hexagrams: {
    title: '六十四卦',
    subtitle: '易经六十四卦 — 选择适合你的排列顺序',
    hint: '选择一个卦象以查看解读',
    loading: '正在加载卦象目录…',
    error: '无法加载卦象目录。',
    retry: '重试',
    order: {
      title: '顺序',
      kingWen: '1–64',
      'king-wen': '1–64',
      fuXi: 'Fu Xi',
      'fu-xi': 'Fu Xi',
      mawangdui: 'Mawangdui',
    },
    matrix: {
      accessibilityLabel: '六十四卦矩阵。顺序：{{order}}',
      cellAccessibilityLabel: '第 {{number}} 卦。{{name}}',
    },
    modal: {
      accessibilityLabel: '第 {{number}} 卦。{{name}}',
      number: '第 {{number}} 卦',
      close: '关闭卦象详情',
      modernTitle: '现代解读',
      pattern: '正在发生什么',
      tension: '困难在哪里',
      structureTitle: '局面结构',
      visibleStructure: '局面如何形成',
      hiddenDynamic: '深层正在发生什么',
      rolesTitle: '卦象的作用',
      initialRole: '当卦象描述当前局面时',
      resultingRole: '当卦象代表可能的状态时',
      roleSummary: '作用的含义',
      action: '如何行动',
      entry: '如何进入这一状态',
      marker: '进展的标志',
      linesTitle: '六爻',
      spheresTitle: '针对所选主题的行动',
      spheres: {
        general: '处境或选择',
        newjob: '新工作',
        work: '当前工作',
        love: '关系',
        project: '项目',
      },
      dailyTitle: '每日指引',
      dailyFocus: '每日主题',
      dailyAction: '实际的一步',
    },
  },
  journal: {
    actionsFor: '“{{title}}”的操作',
    entryActions: '记录操作',
    deleteConfirm: '删除记录？',
    deleteEntry: '删除',
    cancelDelete: '取消',
    deleting: '正在删除…',
    deleteDailyHint:
      '此卦象将被删除。如果它是当前卦象，该日期保留的最新卦象将取代它。当天的第一个卦象会保留。',
    deleteReadingHint: '此解读及其已记录的决定将被永久删除。',
    deleteError: '无法确认删除。请重试。',
    selectEntry: '选择一条日记记录',
    entryNotFound: '未找到记录。请选择列表中的其他记录。',
    title: '记录',
    filters: {
      all: '全部',
      decisions: '解读',
      daily: '每日卦象',
    },
    searchPlaceholder: '按标题和笔记搜索',
    empty: '你的解读将显示在这里',
    emptyHint: '点击“开始占卜”后，将显示第一次解读',
    emptyAll: '你的日记记录将显示在这里',
    emptyAllHint: '解读与每日卦象按时间保存在一起',
    emptyDecisions: '你的解读将显示在这里',
    emptyDecisionsHint: '点击“开始占卜”后，将显示第一次解读',
    emptyDaily: '你的每日卦象将显示在这里',
    emptyDailyHint: '在占卜页面获取第一个卦象',
    error: '无法加载日记',
    errorHint: '请检查连接后重试',
    retry: '重试',
    labels: {
      decision: '起卦',
      accepted: '解读 · 已记录决定',
      daily: '每日卦象',
      question: '问题',
    },
  },
  profile: {
    title: '个人资料',
    account: {
      title: '账户',
      loginTelegram: '通过 Telegram 继续',
      loginHint: '账号历史记录可在多台设备上访问；本地记录将保留在此设备上',
      loginUnavailable: '接入 Telegram Login 后即可登录',
      synchronized: '账号数据在设备间同步',
      logout: '退出账户',
      loginErrorTitle: '登录失败',
      loginError: 'Telegram 未确认登录。请重试。',
      logoutErrorTitle: '退出失败',
      logoutError: '请检查连接后重试。',
    },
    subscription: {
      title: '订阅',
      active: '已生效',
      expired: '已到期',
      free: '免费模式',
      activeUntil: '有效期至 {{date}}',
      manage: '管理订阅',
      connect: '开通 Neiro+',
      restore: '恢复购买',
      hint: '获取深入解读、方案比较和个人建议。',
      restored: '购买已恢复',
      restoreError: '无法恢复购买',
      purchaseError: '无法发起 App Store 订阅',
      loading: '正在检查状态…',
      benefits: {
        extendedInterpretations: '深入解读',
        personalAdvice: '个人建议',
        comparisons: '比较方案',
      },
      whatsIncluded: '包含哪些内容？',
    },
    notifications: {
      title: '通知',
      morning: '早晨',
      morningHint: '选择接收晨间卦象的时间和方式',
      morningEnabledDestinationsHint:
        '每日卦象于 {{time}} 更新 · {{destinations}}',
      morningDisabledDestinationsHint: '每日卦象于 {{time}} 更新；通知已关闭',
      destinations: {
        title: '提醒发送至',
        local: '此 Mac',
        telegram: 'Telegram',
      },
      timeHint: '早晨时间',
      invalidTime: '请按 HH:MM 格式输入时间，例如 09:00',
      timePicker: {
        title: '你的早晨何时开始？',
        descriptionEnabled: '此时每日卦象将更新，Telegram 机器人会发送提醒。',
        descriptionEnabledLocal: '此时每日卦象将更新，macOS 会显示提醒。',
        descriptionEnabledMultiple: '此时每日卦象将更新，所选渠道会发送提醒。',
        descriptionDisabled: '此时每日卦象将更新，通知仍保持关闭。',
        descriptionChannelUnavailable:
          '此时每日卦象将更新。Telegram 渠道可用后会开始发送提醒。',
        descriptionChannelUnavailableLocal:
          '此时每日卦象将更新。macOS 将请求通知权限。',
        quickChoice: '快速选择',
        setPreset: '设为 {{time}}',
        hours: '时',
        minutes: '分',
        decreaseHours: '减少一小时',
        increaseHours: '增加一小时',
        decreaseMinutes: '减少五分钟',
        increaseMinutes: '增加五分钟',
        directEntryHint: '可用键盘输入准确数值',
        invalidHours: '请输入 00 至 23 之间的小时数',
        invalidMinutes: '请输入 00 至 59 之间的分钟数',
      },
      loadError: '无法加载早晨设置',
      saveError: '无法保存早晨设置',
      retry: '重试',
      testSent: '测试消息已发送至 Telegram',
      testSentLocal: '测试通知将在两秒后显示',
      testSentMultiple: '测试提醒已发送至所选渠道',
      testError: '无法发送测试消息',
      channel: {
        active: 'Telegram 机器人已就绪',
        unverified: '打开 Telegram 机器人并确认接收消息',
        blocked: 'Telegram 机器人已被屏蔽。请在 Telegram 中解除屏蔽',
        disconnected: '与 Telegram 机器人的连接已断开',
        not_connected: '尚未连接 Telegram 机器人',
      },
      localChannel: {
        active: '已允许 macOS 通知',
        unverified: '尚未确认 macOS 通知权限',
        blocked: '请在 macOS 设置中允许通知',
        disconnected: 'macOS 通知目前不可用',
        not_connected: '启用提醒时将请求权限',
      },
      testNotification: '发送测试',
    },
    preferences: {
      title: '偏好设置',
      haptics: '触觉反馈',
      hapticsHint: '抛掷和保存时轻微振动',
    },
    classicalText: {
      title: '卦象文本',
      hint: '选择现代解读、传世《周易》原文，或同时显示两者',
      modern: '现代',
      classical: '经典',
      parallel: '两者',
    },
    language: {
      interface: '界面语言',
      russian: 'Русский',
      english: 'English',
    },
    data: {
      title: '数据与隐私',
      exportJournal: '导出记录',
      exportPeriod: '时间范围',
      allData: '全部数据',
      last30Days: '最近 30 天',
      export: '导出',
      exportError: '导出失败',
      deleteAccount: '删除个人数据和账号',
      deleteAccountHint: '将从应用中删除个人数据、历史记录、偏好设置和账号',
      deleteAccountConfirm:
        '个人资料、日记、偏好设置和账号将被删除。下次登录时会创建新账号。仅保留不含内容的技术凭据：Telegram 凭据保留 7 天以防止重复处理，删除确认保留 30 天。到期后这些凭据会自动清除。',
      deleteAccountError: '无法删除个人数据和账号。请检查连接后重试。',
      deleteLocalData: '删除全部个人数据',
      deleteLocalDataHint: '将删除此应用存储在设备上的历史记录和偏好设置',
      deleteLocalDataConfirm:
        '此应用在设备上存储的全部数据将被删除，随后打开全新的初始页面。',
      deleteLocalDataError: '无法删除应用数据。请重试。',
      cancel: '取消',
      deleteAccountAction: '删除账号',
      deleteLocalDataAction: '删除数据',
      privacy: '隐私政策',
      terms: '使用条款',
      disclaimer: '用于自我反思与娱乐，不构成医疗或财务建议。',
    },
    support: {
      title: '支持',
      guide: '如何使用易经占卜',
      guideHint: '每日卦象、解读与日记',
      contact: '联系支持',
      rate: '为应用评分',
      rateNow: '立即评分',
      version: '版本 {{version}}',
      devTools: '开发工具',
      devToolsDesc: '远程配置、推送测试、模拟数据（占位）',
    },
    about: {
      title: '关于',
      version: '版本 {{version}}',
      platform: '{{platform}}',
    },
    resolveNow: '现在决定',
  },
};
